export default __webpack_public_path__ + "static/media/Blog_8flowChapt.113e3e84.webp";